module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_3-79598f8562f5600c9b4c28b7cf5186f8.jpg";